import { render, staticRenderFns } from "./BankFooter.vue?vue&type=template&id=11d24d31&scoped=true"
import script from "./BankFooter.vue?vue&type=script&lang=js"
export * from "./BankFooter.vue?vue&type=script&lang=js"
import style0 from "./BankFooter.vue?vue&type=style&index=0&id=11d24d31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d24d31",
  null
  
)

export default component.exports